/* eslint-disable max-len */
const OnlinePaymentsCheckoutAPI = require('./OnlinePaymentsCheckoutAPI');
const OnlinePaymentsCheckoutPro = require('./OnlinePaymentsCheckoutPro');
const OnlinePaymentsPaymentLink = require('./OnlinePaymentsPaymentLink');

module.exports = { OnlinePaymentsCheckoutAPI, OnlinePaymentsCheckoutPro, OnlinePaymentsPaymentLink };
